<template>
    <div class="cp-question-site">
        <div class="content">
            <div class="question">
                <div v-if="data.required == 1" class="mark">*</div>
                <div class="seq">{{sort < 10 ? '0' + sort : sort}}</div>
                <span>{{data.subject}}</span>
                <span v-if="(data.qtype == 3 || data.qtype == 307) && parseInt(data.alength)">&nbsp;({{data.alength}}个字符以内)</span>
                <span v-if="/^2/.test(data.qtype) && data.minnum != data.maxnum">&nbsp;({{ isEn ? (parseInt(data.maxnum) === (data.options && data.options.length) ? 'Select all that apply' : `Select up to ${data.maxnum} options.`) : `请选择${data.minnum}~${data.maxnum}项` }})</span>
                <span v-if="/^2/.test(data.qtype) && data.minnum == data.maxnum">&nbsp;(请选择{{data.minnum}}项)</span>
            </div>
            <div class="options-container">
                <div v-if="/^[1|2|4]/.test(data.qtype)">
                    <div
                        :class="['options', item.selected ? 'selected' : '']"
                        v-for="(item, index) in data.options"
                        @click="itemOnClick(index)"
                        :key="index"
                        :style="{backgroundColor: optionColor ? optionColor : ''}"
                    >
                        <div class="selector"
                            :class="{'selected': item.selected, 'selector-2': data.qtype == 2, 'selector-1': /^[1|4]/.test(data.qtype)}"
                            :style="{borderColor: item.selected && optionHighlightColor ? optionHighlightColor : ''}"
                        >
                            <div class="selector-center"
                                v-if="item.selected"
                                :style="{
                                    borderColor: item.selected && optionHighlightColor ? optionHighlightColor : '',
                                    backgroundColor: data.qtype == 2 ? '' : item.selected && optionHighlightColor ? optionHighlightColor : ''
                                }"
                            ></div>
                        </div>
                        <span>{{item.content}}</span>
                        <input
                            class="input"
                            v-if="item.remark == 1"
                            type="text"
                            :disabled="!item.selected"
                            v-model="item.text"
                            @change="updateItemContent(index)"
                            @click="onclick($event)">
                        <span v-if="item.selected && item.content_required == 1" style="color: red">*</span>
                    </div>
                </div>
                <!-- 矩阵打分 -->
                <div class="matrix-table-wrapper">
                    <table v-if="data.qtype == 6" class="q_matrix_score">
                        <thead>
                            <tr>
                                <th v-if="ismultiple"></th>
                                <th
                                :style="{'width': (ismultiple ? 83 : 100)/(data.options.length) + '%'}"
                                v-for="(option, oIndex) in data.options"
                                :key="oIndex">
                                    <div class="star_tips">
                                    {{option.content}}
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                        <tr class="matrix_item" v-for="(row, dIndex) in data.rows" :key="dIndex">
                            <td class="sub_title" v-if="ismultiple">
                                <div class="subtitle_text">
                                    {{row.content}}
                                </div>
                            </td>
                            <td v-for="(item, oIndex) in data.options" :key="oIndex" style="position: relative" @click="itemOnClick(oIndex, dIndex)">
                                <div class="selector selector-1"
                                    :class="{'selected': row.val == oIndex}"
                                    :style="{borderColor: row.val == oIndex && optionHighlightColor ? optionHighlightColor : ''}"
                                >
                                    <div class="selector-center"
                                        v-if="row.val == oIndex"
                                        :style="{
                                            borderColor: row.val == oIndex && optionHighlightColor ? optionHighlightColor : '',
                                            backgroundColor: row.val == oIndex && optionHighlightColor ? optionHighlightColor : ''
                                        }"
                                    >
                                    </div>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <!-- 填空题 -->
                <div class="options-input"
                    v-if="data.qtype == 3 || data.qtype == 307"
                    :class="{'selected': data.selected}"
                    @click="itemOnClick()"
                    :style="{backgroundColor: optionColor ? optionColor : ''}"
                >
                    <textarea
                        :style="{color: textColor}"
                        :placeholder="'请输入'"
                        :rows="Math.max(data.rowsnum, 7)"
                        v-model="data.content"
                        @change="updateContent"
                    >
                    </textarea>
                </div>
                <div v-if="data.qtype == 5" class="ShowImgCon">
                    <div class="simg"
                        :class="{'checked': item.selected}"
                        v-for="(item, index) in data.options"
                        :key="index"
                        @click="itemOnClick(index)">
                        <div class="simgbox">
                            <img :src="item.pic">
                        </div>
                        <div class="optionImg">
                            <div class="optionImg_wrap">
                                <div class="selector selector-1"
                                    :class="{'selected': item.selected}"
                                    :style="{borderColor: item.selected && optionHighlightColor ? optionHighlightColor : ''}"
                                >
                                    <div class="selector-center"
                                        v-if="item.selected"
                                        :style="{
                                            borderColor: item.selected && optionHighlightColor ? optionHighlightColor : '',
                                            backgroundColor: item.selected && optionHighlightColor ? optionHighlightColor : ''
                                        }"
                                    ></div>
                                </div>
                                <div class="img_txt">{{item.content}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <el-cascader
                    style="width: 350px"
                    ref="cascaderAddr"
                    v-if="data.qtype == 305"
                    filterable
                    clearable
                    expand-trigger="hover"
                    @change="citySelected"
                    :options="options"
                    v-model="selectedOptions">
                </el-cascader>
                <!-- <select-address v-if="data.qtype == 305" v-on:citySelected="citySelected"></select-address> -->
            </div>
        </div>
    </div>
</template>

<script>
  import maps from '../map.js'

  export default {
    props: ['data', 'sort', 'optionHighlightColor', 'optionColor', 'textColor', 'isEn'],
    methods: {
      /**
       * 选择题点击选项
       * @param name
       * @param params
       */
      itemOnClick(oIndex, dIndex){
        let toSent = {
            qid: this.data.qid,
            qtype: this.data.qtype
        };
        if(oIndex >= 0) {
            toSent.index = oIndex;
            toSent.text = this.data.options[oIndex].text;
        }
        if(dIndex >= 0) {
            toSent.dIndex = dIndex;
        }
        this.$emit('itemClick', toSent);
      },
      updateItemContent(index) {
        let toSent = {
            qid: this.data.qid,
            qtype: this.data.qtype
        };
        if(index >= 0) {
            toSent.index = index;
            toSent.text = this.data.options[index].text;
        }
        this.$emit('itemContentUpdate', toSent);
      },
      citySelected() {
          this.data.content = this.$refs['cascaderAddr'].currentLabels.join(' ');
          this.updateContent();
      },
      onclick(e) {
          e.stopPropagation();
      },
      updateContent() {
        let toSent = {
            qid: this.data.qid,
            content: this.data.content
        };
        this.$emit('contentUpdate', toSent);
      }
    },
    watch: {
      'data': {
          handler (val) {
            if(val.rows && val.rows.length) {
              this.ismultiple = val.rows.length >= 2 || val.rows[0].content;
            }
          },
          deep: true,
          immediate: true,
      },
    },
    data(){
        return {
            options: maps.map,
            selectedOptions: [],
            ismultiple: true
        }
    }
  }
</script>

<style rel="stylesheet/stylus" lang="stylus" scoped>
@import '../../assets/stylus/minixs/_center.styl';
.cp-question-site
    width 100%
    margin-top 45px

    .content
        width 100%
        // padding-right 49px
        font-size 14px
        .matrix-table-wrapper
            overflow-x auto;
        .q_matrix_score
            // padding-right 49px;
            width 100%
            font-size 14px;
            border-collapse: collapse
            tr
                border-bottom: 1px solid rgba(0,0,0,0.1);
            th
                font-weight normal
                padding-bottom: 16px;
            .sub_title
                line-height: 1.5;
                display: flex;
                align-items: center;
                max-width: 171px;
                padding: 8px 0;
            .selector
                left 50%
                top 50%
                margin-left -6px;
                margin-top -8px;
                position absolute
        .options-container
            // padding-left 49px
        .question
            font-size 16px
            width 100%
            line-height 32px
            margin-bottom 14px
            padding-right 2px
            position relative
            font-size: 18px;
            .seq
                height 32px
                margin-right: 8px;
                text-align center
                float left
            .mark
                position: absolute;
                left: -14px;
                top: 1px;
                background-size: 100%;
                vertical-align: -2px;
                margin-right: 4px;
                color: rgb(218,35,25);
            .multi
                color white
                font-size 20px
        .ShowImgCon
            .simg
                display: inline-block;
                width: 138px;
                background-color: #ffffff;
                border-radius: 4px;
                overflow: hidden;
                vertical-align: top;
                border: solid 1px #dde5ed;
                margin-bottom: 20px;
                margin-right: 15px;
                &.checked
                    background-color: rgba(38,114,255,0.2);
                    box-shadow: 0 2px 4px 0 rgba(38,114,255,0.2);
                    animation: buttonSelected 0.25s cubic-bezier(0.42, 0, 0.58, 0.1);
                    -webkit-animation: buttonSelected 0.25s cubic-bezier(0.42, 0, 0.58, 0.1);
                    .optionImg
                        border-bottom-left-radius: 4px;
                        border-bottom-right-radius: 4px;
                .simgbox
                    margin: 0 auto;
                    border-top-left-radius: 4px;
                    border-top-right-radius: 4px;
                    position: relative;
                    width: 100%;
                    img {
                        width 100%
                        height 138px
                        object-fit: contain
                    }

                .optionImg
                    padding: 9px 10px 14px 34px;
                    position: relative;
                    .img_txt
                        font-size: 14px;
                        word-wrap: break-word;
                    .ico_radio
                        top: 50%;
                        left: 10px;
                        border-radius: 50%;
        .options
            padding-left 30px
            border-radius: 4px;
            line-height 36px
            position relative
            box-sizing content-box
            margin: 0 -8px;
            cursor pointer
            &:hover
                background-color: #EBF3FD;
            // background-color: rgba(38,114,255,0.2);
            &-input
                margin-top: 9px;
                width: 100%;
                box-sizing: border-box;
                border-radius: 3px;
                overflow: auto;
                transition: all 0.2s;
                textarea
                    border: 1px solid #cbd5de;
                    width: 100%;
                    height: 100%;
                    padding: 8px 20px;
                    border-radius: 3px;
                    &:hover
                        border-color: rgb(35,120,255);
            &.selected
                // box-shadow: 0 2px 4px 0 rgba(38,114,255,0.2);
                color: #018fff;
                animation: buttonSelected 0.25s cubic-bezier(0.42, 0, 0.58, 0.1);
                -webkit-animation: buttonSelected 0.25s cubic-bezier(0.42, 0, 0.58, 0.1);
            .input
                border-bottom: 1px solid #333
                width: 390px
                font-size: 14px
                height: 28px
                line-height 28px
                padding-left: 10px;
                margin-left 10px;
    .selector
        border: 1px solid #cbd5de;
        width: 16px
        height: 16px
        display flex
        justify-content center
        align-items center
        left 8px
        top 10px
        position absolute
        box-sizing border-box
        cursor pointer
        &-2
            border-radius: 2px
            .selector-center
                width: 5px;
                height: 9px;
                border-right-style: solid;
                border-bottom-style: solid;
                border-right-width: 2px;
                border-bottom-width: 2px;
                transform: rotate(45deg);
                transform-origin 90% 40%
                border-color: #4483c1;
            &.selected
                border-color: #018fff;
        &-1
            border-radius: 50%
            &.selected
                border-width 4px;
                border-color: #018fff;

    @keyframes buttonSelected {
        0% {
            transform: translateY(0);
        }
        40% {
            transform: translateY(-5px);
        }
        100% {
            transform: translateY(0);
        }
    }

</style>
